var exports = {
  "E3": "ConfirmMergeContainer__qHwk8t",
  "Sn": "ConfirmMergeText___IKSTF",
  "qL": "StackAutoMergeDescription__wNncPo",
};

module.exports = exports;
